@if (loggedIn()) {
<nav-menu></nav-menu>
}

<main [class]="mainClasses">
    @if (isLoading) {
    <div class="loading-spinner-container">
        <div class="loading-spinner">
        </div>
    </div>
    }
    <div class="loading__asset">
        <router-outlet>
        </router-outlet>
    </div>
    <!-- <router-outlet></router-outlet>  -->
</main>

@if (disclaimerNotAccepted === true && disclaimerAllowedOnPage === true ) {
<disclaimer></disclaimer>
}

@if (loggedIn()) {
<footer-menu></footer-menu>
}